import axios from 'axios';

export const API_URL = `${process.env.REACT_APP_BASE_URL}`+'api';

export const PROD_WEB_URL = "https://www.cms.browsmart.com.au/"; // `${process.env.REACT_APP_BASE_URL}` ;// 'https://www.browsmart.com.au/';

export const register = async (userData) => {
  const response = await axios.post(`${API_URL}/register`, userData);
  return response.data;
};

export const staff = async (userData) => {
  const response = await axios.post(`${API_URL}/staff-register`, userData, {
    headers: {
      "content-type": "multipart/form-data"
    },
  });
  return response.data;
};


export const staffEdit = async (id,userData) => {
  const response = await axios.post(`${API_URL}/staff-update/`+id, userData, {
    headers: {
      "content-type": "multipart/form-data"
    },
    
  });
  return response.data;
};

export const customer = async (userData) => {
  const response = await axios.post(`${API_URL}/customer-register`, userData);
  return response.data;
};
export const customerEdit = async (id,userData) => {
  const response = await axios.post(`${API_URL}/customer-update/`+id, userData);
  return response.data;
};

export const login = async (userData) => {
  const response = await axios.post(`${API_URL}/login`, userData);
  return response.data;
};

export const getEnquiry = async (token) => {
  const response = await axios.get(`${API_URL}/enquiry-all`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const getBrancheslist =() =>{

  return  [
    /*"Select Branch",*/       
    "Liverpool, NSW"/*,
    "Drummoyne, NSW"*/
  ]
}
export const getOrderStatuses =() =>{

  return ["pending", "Assigned", "Service Started", "Payment Pending", "Paid and Closed"];
  
  }